<ion-item button [detail]="true" (click)="onRowClick()">
  <ion-icon slot="start" name="qr-code-outline" aria-hidden="true"></ion-icon>
  <ion-label>
    <p class="crowdctrl-form-short-link-row-title">{{ title }}</p>
    <p class="crowdctrl-form-short-link-row-url">{{ row.shortUrl }}</p>
  </ion-label>
</ion-item>
